import { SchoolQueryDocument } from "@pathwright/graphql-client/src/generated"

export default SchoolQueryDocument
